import clsx from "clsx";
import {
  Box,
  makeStyles,
  Typography,
  Card,
} from "@material-ui/core";
import Page from "src/components/Page";
import React from "react";
import InformationClause from "src/components/common/InformationClause";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(2),
    },
  },
}));

const InformationClauseView = (rest) => {
  const classes = useStyles();

  return (
    <Page className={classes.root} title="Klauzula obowiązku informacyjnego">

      <Box mt={3}>
        <Card className={clsx(classes.root)}>
          <Box display="flex" flexDirection="column">
            <Box>
              <Typography
                color="textPrimary"
                component="h1"
                variant="h2"
                align="center"
                paragraph
              >
                Klauzula obowiązku informacyjnego
              </Typography>
              <InformationClause></InformationClause>
            </Box>
          </Box>
        </Card>
      </Box>
    </Page>
  );
};

export default InformationClauseView;
